<template>
  <div class="user-seeing" @click="moreVisible = false">
    <div
      class="silder-contain slider-admissionCue slider-top-see"
      style="padding-bottom: 0"
    >
      <div class="slider-top clearFloat">
        <p class="h3 slider-title pull-left">{{ seeSliderTitle }}</p>
        <div
          class="pull-right h1 btn-close font-gray"
          @click="hideUserSliderBox"
        >
          <i class="el-icon-close"></i>
        </div>
        <el-button
          v-if="iscanEdit && tabEdit"
          type="primary"
          class="pull-right"
          @click="Clickedit()"
        >
          {{ $t("Common.btn_edit") }}</el-button
        >
        <el-button
          v-if="isRoottrack || isyhavetrackedit"
          type="primary"
          class="pull-right"
          @click="onFllowSubmit(followForm)"
          >{{ $t("Common.btn_submit") }}</el-button
        >
        <!-- // company_ismajor  0是免费版 1是普通版   2是专业版 -->
        <div
          class="btn-binding pull-right"
          v-if="!isHome && companyIsmajor == '2'"
        >
          <div class="biding-more">
            <el-button type="warning" @click.stop="handmoreVisible()">
              {{ $t("User.see_btn_more") }}
              <i class="el-icon-caret-bottom"></i>
            </el-button>
          </div>
          <ul v-show="moreVisible" class="biding-list text-1">
            <li @click="studentBinding()">{{ $t("User.see_btn_bind") }}</li>
          </ul>
        </div>
      </div>
      <div style="height: calc(100vh - 70px); overflow-y: auto">
        <div class="slider-person-info text-1 clearFloat">
          <div class="person" style="display: block">
            <div class="person-img pull-left">
              <img
                v-if="UserInformation.client_img != ''"
                :src="UserInformation.client_img"
              />
              <img
                v-if="
                  UserInformation.client_img == '' &&
                  UserInformation.client_sex ==
                    $t('components.User.seeing.52b5hn58u240')
                "
                src="../../assets/images/default-img-women.png"
              />
              <img
                v-if="
                  UserInformation.client_img == '' &&
                  UserInformation.client_sex !=
                    $t('components.User.seeing.52b5hn58u240')
                "
                src="../../assets/images/default-img-man.png"
              />
            </div>
          </div>
          <div class="myinfo">
            <div class="sele-sty" style="width: 110px; margin-left: 25px"></div>
            <div class="el-info-row">
              <p class="el-col">
                <label>{{ $t("User.label_text1") }}</label>
                {{ UserInformation.client_cnname }}
              </p>
              <p class="el-col">
                <label>{{ $t("User.label_text2") }}</label>
                {{ UserInformation.client_enname }}
              </p>
            </div>
            <div class="el-info-row">
              <p class="el-col">
                <label>{{ $t("User.label_text3") }}</label>
                {{ UserInformation.client_sex }}
              </p>
              <p class="el-col">
                <label>{{ $t("User.label_text4") }}</label>
                {{ UserInformation.client_mobile }}
              </p>
            </div>
            <div class="el-info-row">
              <p class="el-col">
                <label>{{ $t("User.label_text17") }}</label>
                <span class="contact-name">{{
                  UserInformation.main_family_cnname
                }}</span>
                <!-- <span class="addTagBtn ml10" @click="addTagVisable = true"
                >添加标签</span
              > -->
              </p>
              <p class="el-col">
                <label>{{ $t("User.label_text5") }}</label>
                {{ UserInformation.client_birthday }}
              </p>
            </div>
          </div>

          <div class="tag-list">
            <!-- <span
            v-for="(item, index) in UserInformation.client_tag"
            :key="index"
            class="tagItem"
          >
            {{ item }}
          </span> -->
            <span
              v-for="(item, index) in UserInformation.client_tag"
              :key="index"
              class="tagItem"
            >
              {{ item }}
            </span>
            <span
              class="addTagBtn ml10"
              @click="addTagVisable = true"
              style="position: absolute; right: 50px"
              >{{ $t("User.ab") }}</span
            >
          </div>
        </div>
        <div class="slider-cont text-1">
          <el-tabs v-model="activeName" @tab-click="handleSliderClick">
            <el-tab-pane :label="$t('User.tab_pane1')" name="first">
              <!-- <el-form ref="form" :model="form" label-width="100px"> -->
              <p class="form-small-title h3">{{ $t("User.s_title12") }}</p>
              <div class="BaseInfo">
                <p class="form-info-cont">
                  <label>{{ $t("User.label_card") }}</label>
                  <span>{{ UserInformation.client_icard }}</span>
                </p>
                <p class="form-info-cont">
                  <label>{{ $t("User.label_text18_4") }}</label>
                  <span>{{ UserInformation.nearschool_name }}</span>
                </p>
                <p class="form-info-cont">
                  <label>{{ $t("User.label_text18_5") }}</label>
                  <span>
                    {{ UserInformation.school_province }}
                    {{ UserInformation.school_city }}
                    {{ UserInformation.school_area }}
                  </span>
                </p>
              </div>
              <p class="form-small-title h3">{{ $t("User.s_title3") }}</p>
              <div class="BaseInfo">
                <div
                  v-for="item in UserInformation.client_family_list"
                  :key="item.family_id"
                  class="family-info"
                >
                  <p class="form-info-cont">
                    <label>{{ $t("User.label_text18_1") }}</label>
                    <span>{{ item.family_cnname }}</span>
                  </p>
                  <p class="form-info-cont">
                    <label>{{ $t("User.label_text18_2") }}</label>
                    <span>{{ item.family_relation }}</span>
                  </p>
                  <p class="form-info-cont">
                    <label>{{ $t("User.label_text18_3") }}</label>
                    <span>{{ item.family_mobile }}</span>
                  </p>
                  <p class="form-info-cont">
                    <label>微信号：</label>
                    <span>{{ item.family_wechat }}</span>
                  </p>
                    <p class="form-info-cont">
                    <label>Email：</label>
                    <span>{{ item.family_email }}</span>
                  </p>
                </div>
              </div>
              <p class="form-small-title h3">{{ $t("User.s_title4") }}</p>
              <div class="BaseInfo">
                <p class="form-info-cont">
                  <label>{{ $t("User.label_text8") }}</label>
                  <span>{{ UserInformation.client_fromtype_name }}</span>
                </p>
                <p class="form-info-cont">
                  <label>{{ $t("User.label_text9") }}</label>
                  <span>{{ UserInformation.client_source }}</span>
                </p>
                <p class="form-info-cont">
                  <label>{{ $t("User.label_text10") }}</label>
                  <span
                    >{{ UserInformation.channel_name }}
                    <em
                      v-if="channelChangeList.length > 0"
                      @click="linkToDetail"
                      class="channel-link"
                    >
                      查看渠道更改记录 ></em
                    >
                  </span>
                </p>
                 <p class="form-info-cont">
                  <label>接触点:</label>
                  <span>{{ UserInformation.client_frompage || '--' }}</span>
                </p>
                <p class="form-info-cont">
                  <label>{{ $t("User.af") }}：</label>
                  <span>
                    <el-rate
                      v-model="num"
                      disabled
                      score-template="{value}"
                      :icon-classes="['crm-likes', 'crm-likes', 'crm-likes']"
                      void-icon-class="crm-like"
                      disabled-void-icon-class="crm-like"
                      :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
                      style="height: 15px; line-height: 20px"
                    ></el-rate>
                  </span>
                </p>
                <p class="form-info-cont">
                  <label>客户最高意向星级：</label>
                  <span>
                    <el-rate
                      v-model="maxNum"
                      disabled
                      score-template="{value}"
                      :icon-classes="['crm-likes', 'crm-likes', 'crm-likes']"
                      void-icon-class="crm-like"
                      disabled-void-icon-class="crm-like"
                      :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
                      style="height: 15px; line-height: 20px"
                    ></el-rate>
                  </span>
                </p>
                <p class="form-info-cont">
                  <label>{{ $t("User.label_text19") }}</label>
                  <span>
                    {{ UserInformation.client_tracestatus }}
                    <!-- <i class="icon-heart-off"></i>
                  <i class="icon-heart-off"></i>-->
                  </span>
                </p>
                <p class="form-info-cont">
                  <label>{{ $t("User.label_text22") }}</label>
                  <span
                    v-if="UserInformation.client_sponsor"
                    class="recommend-info"
                  >
                    {{ UserInformation.client_sponsor }}
                    {{ UserInformation.student_enname }}
                    {{ UserInformation.re_parenter_mobile }}
                    <span></span>
                    {{ $t("User.label_text23")
                    }}{{ UserInformation.school_cnname }}
                  </span>
                  <span v-else>
                    {{ $t("components.User.seeing.54cy9sbr0wc0") }}
                    <el-button
                      v-if="fromType == 'registeredList'"
                      type="text"
                      @click="addConnect"
                    >
                      {{ $t("components.User.seeing.54cy9sbr4bs0") }}
                      <em class="el-icon-arrow-right"></em>
                    </el-button>
                  </span>
                </p>
                <p class="form-info-cont">
                  <label>来源小区：</label>
                  <span>{{ UserInformation.client_community || "--" }}</span>
                </p>
                <!-- <p class="form-info-cont">
                  <label>{{$t('components.User.seeing.52b5hn58sl40')}}</label>
                  <span>{{UserInformation.main_marketer_name}}</span>
                  </p>
                  <p class="form-info-cont">
                  <label>{{$t('components.User.seeing.52b5hn58swg0')}}</label>
                  <span v-for="item in UserInformation.client_principal_name" :key="item.principal_id">{{item.marketer_name}},</span>
              </p>-->
              </div>

              <template v-if="channelChangeList.length > 0">
                <p class="form-small-title h3">历史渠道变更记录</p>
                <div class="BaseInfo">
                  <div
                    v-for="(activity, index) in channelChangeList"
                    :key="index"
                    class="channel-history"
                  >
                    <div class="channel-history__title">
                      {{ activity.createtime }}
                    </div>
                    <div class="channel-history-box">
                      <div class="channel-row">
                        <div class="channel-detail">
                          <div class="channel-detail__content">
                            <p>{{ activity.from_frommedia_name }}</p>
                            <p>{{ activity.from_channel_name }}</p>
                            <p>{{ activity.channellog_client_frompage }}</p>
                          </div>
                          <div class="channel-detail__tips">
                            <img src="@/assets/images/change-icon.png" alt="" />
                            <p>变更为</p>
                          </div>
                          <div class="channel-detail__content">
                            <p>{{ activity.to_frommedia_name }}</p>
                            <p>{{ activity.to_channel_name }}</p>
                            <p>&nbsp;</p>
                          </div>
                        </div>
                        <!-- channellog_status`  '0待审核1审核通过-1审核未通过', -->
                        <div
                          class="channel-status"
                          :class="{
                            'status-success': activity.channellog_status == 1,
                            'status-fail': activity.channellog_status == -1,
                            'status-wait': activity.channellog_status == 0,
                          }"
                        >
                          <span class="dot"></span>
                          {{
                            activity.channellog_status == "0"
                              ? "待审核"
                              : activity.channellog_status == "1"
                              ? "审核通过"
                              : activity.channellog_status == "-1"
                              ? "审核未通过"
                              : ""
                          }}
                        </div>
                      </div>
                      <template v-if="activity.tracks_title == 0">
                        <p class="channel-history__teacher">
                          申请人：{{ activity.staffer_cnname }}
                        </p>
                        <p class="mt10">
                          申请变更时间：
                          {{ activity.channellog_changetime || "--" }}
                        </p>
                        <p class="mt10">
                          备注： {{ activity.channellog_reason }}
                        </p>
                        <p v-if="activity.channellog_img" class="mt10">
                          附件：
                          <span
                            @click="emitShowImg(activity.channellog_img)"
                            style="color: #20a8d8; cursor: pointer"
                            >图片</span
                          >
                        </p>
                      </template>
                      <template v-else>
                        <p class="channel-history__teacher">
                          审核人：{{ activity.astaffer_cnname }}
                        </p>
                        <p class="mt10">
                          申请变更时间：
                          {{ activity.channellog_changetime || "--" }}
                        </p>
                        <p class="mt10">
                          备注： {{ activity.channellog_note }}
                        </p>
                        <p v-if="activity.channellog_img" class="mt10">
                          <!--showImgUrl = activity.channellog_img, showImgMask = true-->
                          附件：
                          <span
                            @click="emitShowImg(activity.channellog_img)"
                            style="color: #20a8d8; cursor: pointer"
                            >图片</span
                          >
                        </p>
                      </template>
                    </div>
                  </div>
                  <p
                    v-if="channelChangeList.length == '0'"
                    class="no-data pt30 pb30"
                  >
                    <i class="el-icon-document"></i>
                    暂无变更记录
                  </p>
                </div>
              </template>

              <p class="form-small-title h3">{{ $t("User.s_title5") }}</p>
              <div class="BaseInfo">
                <p class="form-info-cont">
                  <label>{{ $t("User.label_text15") }}</label>
                  <span
                    class="course"
                    v-for="item in UserInformation.client_course_list"
                    :key="item.intention_id"
                    >{{ item.coursecat_cnname }}</span
                  >
                  <!-- <span class="course">语法课程</span>

                <span class="course">{{$t('components.User.seeing.52b5hn58t480')}}</span>-->
                </p>
              </div>
              <p class="form-small-title h3">{{ $t("User.s_title6") }}</p>
              <div class="BaseInfo">
                <p class="form-info-cont">
                  <label>{{ $t("User.label_text16") }}</label>
                  <span>{{ UserInformation.client_remark }}</span>
                </p>
              </div>
              <!-- <el-form-item>
            <el-button type="primary" @click="onSubmit">{{$t('components.User.seeing.52b5hn58tas0')}}</el-button>
            <el-button @click="hideSliderBox()">{{$t('components.User.seeing.52b5hn58ths0')}}</el-button>
            </el-form-item>-->
              <!-- </el-form> -->
            </el-tab-pane>
            <el-tab-pane :label="$t('User.tab_pane2')" name="second">
              <div class="slider-trackRecord">
                <div class="record-info">
                  <p class="form-small-title h3">{{ $t("User.s_title7") }}</p>

                  <div class="content-nav--head">
                    <div class="c-n--head_lf">
                      <div class="flex items-center justify-between">
                        <ul class="filter-condition">
                          <li
                            v-for="(item, index) in filtersOption"
                            :key="index"
                            :class="{ 'link-active': item.id == currentId }"
                            @click="changeFilter(item)"
                          >
                            {{ item.label }}
                            <span class="tag-num" v-if="item.value">
                              {{ item.value }}
                            </span>
                          </li>
                        </ul>
                        <el-button
                          type="primary"
                          size="mini"
                          @click="addTrackVisible = true"
                          v-if="showAddTrack"
                        >
                          补充备注
                        </el-button>
                      </div>
                    </div>
                  </div>

                  <el-row v-for="(items, index) in recordData" :key="index">
                    <el-col :span="4">
                      <div class="grid-content bg-purple grid-content-img">
                        <img
                          v-if="
                            items.marketer_img != '' &&
                            items.marketer_img != null
                          "
                          :src="items.marketer_img"
                        />
                        <img
                          v-else-if="
                            items.staffer_sex ==
                            $t('components.User.seeing.52b5hn58u240')
                          "
                          :src="photoImgWomen"
                        />
                        <img v-else :src="photoImgmen" />
                      </div>
                    </el-col>
                    <el-col :span="20">
                      <div class="grid-content bg-purple-light text-1">
                        <p class="clearFloat">
                          {{ items.marketer_name }}
                          <span
                            v-if="items.track_linktype"
                            class="btn-purple font-gray"
                          >
                            {{ items.track_linktype }}
                          </span>
                          <span
                            v-if="items.track_followcont"
                            class="btn-purple font-gray"
                          >
                            {{ items.track_followcont }}
                          </span>
                          <span
                            v-if="items.coursetype_cnname"
                            class="btn-purple font-gray"
                          >
                            {{ items.coursetype_cnname }}
                          </span>
                          <span class="font-gray show-time pull-right">{{
                            items.track_createtime
                          }}</span>
                        </p>
                        <p>
                          {{ $t("User.follow_label2") }}{{ items.object_name }}
                        </p>
                        <p v-if="items.track_followmode == '2'">
                          {{ $t("User.tryDate") }}{{ items.track_visitingtime }}
                        </p>
                        <p v-if="items.track_followmode == '2'">
                          {{ $t("User.tryClass") }}{{ items.class_cnname }}
                        </p>
                        <p v-if="items.track_followmode == '1'">
                          {{ $t("User.guiDate") }}{{ items.track_visitingtime }}
                        </p>
                        <p
                          v-if="
                            items.track_followuptime &&
                            items.track_followuptime != ''
                          "
                        >
                          {{ $t("User.nextFollowDate")
                          }}{{ items.track_followuptime }}
                        </p>
                        <p v-if="false">
                          {{ $t("User.typecname") }}
                          {{ items.coursetype_cnname }}
                        </p>

                        <div class="flex-all" style="line-height: 28px">
                          <p>
                            {{ $t("User.followSchool") }}
                            {{ items.school_cnname }}
                          </p>

                          <p
                            v-if="items.track_isreading == '1'"
                            class="text-3 mb10"
                          >
                            {{ items.level_marketer_name }}
                            <span class="font-gray"
                              >{{ $t("User.label_text20")
                              }}{{ items.track_readtime
                              }}{{ $t("User.btn_text4") }}</span
                            >
                          </p>
                        </div>

                        <div
                          class="flex items-center"
                          style="line-height: 28px"
                          v-if="
                            items.track_intention_level &&
                            items.track_intention_level > 0
                          "
                        >
                          意向星级：
                          <div class="flex items-center">
                            <span
                              class="fs20 crm-likes"
                              v-for="(icon, iconIndex) in Number(
                                items.track_intention_level
                              )"
                              :key="iconIndex"
                            ></span>
                          </div>
                        </div>

                        <p v-if="items.track_followmode == -3">
                          无效原因：{{ items.track_invalidreason }}
                        </p>

                        <!-- 沟通内容 -->
                        <div class="communite-cont mb20">
                          <p>
                            {{ $t("User.communiteContent") }}
                            <span
                              :class="[
                                items.track_note == '未接通' ? 'font-red' : '',
                              ]"
                              >{{ items.track_note || "--" }}</span
                            >
                          </p>
                          <div
                            v-if="
                              postbe_crmlevel == '1' &&
                              items.track_isactive == '1'
                            "
                            class="btns"
                          >
                            <el-button
                              v-if="items.track_isreading == '0'"
                              type="warning"
                              @click="handRead(items, index)"
                            >
                              {{ $t("User.btn_text4") }}</el-button
                            >
                            <el-button
                              v-else
                              type="warning"
                              disabled
                              class="btn-disabled"
                              >{{ $t("User.btn_text5") }}
                            </el-button>
                            <el-button
                              type="primary"
                              v-if="!items.isClickReply"
                              :disabled="items.replay_id > 0"
                              :class="{ 'btn-disabled': items.replay_id > 0 }"
                              @click="handReply(items, index)"
                            >
                              {{ $t("User.btn_text6") }}</el-button
                            >
                          </div>
                        </div>
                        <!-- 回复内容 -->
                        <!-- 回复弹框 -->
                        <div
                          v-if="postbe_crmlevel == '1' && items.isClickReply"
                          class="communite-replay mb20"
                        >
                          <div class="img mt20 mb10">
                            <img
                              v-if="
                                items.login_marketer_img != '' &&
                                items.login_marketer_img != null
                              "
                              :src="items.login_marketer_img"
                            />
                            <img
                              v-else-if="
                                items.login_marketer_sex ==
                                $t('components.User.seeing.52b5hn58u240')
                              "
                              :src="photoImgWomen"
                            />
                            <img v-else :src="photoImgmen" />
                          </div>
                          <div class="replay-cont">
                            <div class="replay-top mt20 mb10">
                              <span>
                                {{ items.login_marketer_name }}
                                <span class="font-gray ml5 mr5">{{
                                  $t("User.btn_text6")
                                }}</span>
                                {{ items.marketer_name }}
                              </span>
                              <div class="btns">
                                <el-button
                                  type="primary"
                                  @click="levelReplayTrackAction(items, index)"
                                >
                                  {{ $t("Common.btn_confirm") }}</el-button
                                >
                                <el-button
                                  plain
                                  @click="handCloseReply(items, index)"
                                  >{{ $t("Common.btn_cancel") }}
                                </el-button>
                              </div>
                            </div>
                            <el-input
                              type="textarea"
                              rows="3"
                              style="width: 485px"
                              :placeholder="$t('User.replay_placeholder')"
                              v-model="items.replay_note"
                            ></el-input>
                          </div>
                        </div>
                        <!-- 回复列表 -->
                        <div
                          v-if="
                            items.replay_info && items.replay_info.length > 0
                          "
                          class="replay-list"
                        >
                          <div
                            v-for="(item1, index1) in items.replay_info"
                            :key="index1"
                            class="communite-replay"
                          >
                            <div class="img mt20 mb10">
                              <img
                                v-if="
                                  item1.marketer_img != '' &&
                                  item1.marketer_img != null
                                "
                                :src="item1.marketer_img"
                              />
                              <img
                                v-else-if="
                                  item1.staffer_sex ==
                                  $t('components.User.seeing.52b5hn58u240')
                                "
                                :src="photoImgWomen"
                              />
                              <img v-else :src="photoImgmen" />
                            </div>
                            <div class="replay-cont">
                              <div class="replay-top mt20 mb10">
                                <span>
                                  {{ item1.marketer_name }}
                                  <span class="font-gray ml5 mr5">{{
                                    $t("User.btn_text6")
                                  }}</span>
                                  {{ items.marketer_name }}
                                </span>
                                <span class="font-gray">{{
                                  item1.replay_createtime
                                }}</span>
                              </div>
                              <p>{{ item1.replay_note }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                  <p v-if="recordDatalen == '0'" class="no-data pt30 pb30">
                    <i class="crm-wu"></i>
                    {{ $t("User.noFollowRecord") }}
                  </p>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('User.tab_pane3')" name="third">
              <div class="slider-tryRecord">
                <p class="form-small-title h3">{{ $t("User.s_title8") }}</p>
                <tipsTable
                  :list="tryRecordlist"
                  :options="recordoptions"
                  :columns="recordlistColumn"
                  :operates="recordOperates"
                ></tipsTable>
                <p class="form-small-title h3">{{ $t("User.s_title9") }}</p>
                <tipsTable
                  :list="tryClasslist"
                  :options="Classoptions"
                  :columns="ClasslistColumn"
                  :operates="ClassOperates"
                ></tipsTable>
              </div>
            </el-tab-pane>
            <!--&& (UserInformation.client_tracestatus_status!='4')-->
            <el-tab-pane :label="$t('User.ac')" name="sixed">
              <div class="slider-phoneRecord">
                <div class="form-small-title h3">
                  {{ $t("components.User.seeing.52b5hn58ug80") }}
                </div>
                <div v-if="OutboundList.length > 0" class="Outbound-list">
                  <!-- <div class="user flex-al fs15">
                  <img
                    v-if="UserInformation.client_img"
                    :src="UserInformation.client_img"
                    style="width: 45px;height:45px;"
                  />
                  <img
                    v-else-if="UserInformation.client_sex == '女'"
                    src="../../assets/images/default-img-women.png"
                    style="width: 45px;height:45px;"
                  />
                  <img
                    v-else-if="UserInformation.client_sex != '男'"
                    src="../../assets/images/default-img-man.png"
                    style="width: 45px;height:45px;"
                  />
                  <span class="ml10 mr10">呼叫中心测试</span>
                  <img
                    v-if="UserInformation.client_sex == '女'"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAFLUlEQVRYR62Xa2xUVRDHf7Olj10FaowFAhrBaKJBjGJMLCZEJCpQDGKIL8IjSn2Uhjaw99oG3Swo7b1bQ02xakVTQkAiqEEeqYQGxICPKMaYqInREj9ArAoFmi4Fdsec7dLubvclcj7eO4//zJn5zxwhz6PV1cUUF8/G45kBTEXkRlSvQSQKnEL1d0S+JRrdh8+3X4LBi/mYllxCumLFGIqLLeAZYHQu+fj/vxFppb9/vTQ392TTyQhAVQXbXgG8ClyVp+NUsVNArbjupkz6aQGobY8mGt2ByMzLdJysJvIhJSWLJRg8l2pvGAD1+8ci8hkw5Yo4HzLyBeFwhbS0nEm0mwRAKyt9lJZ+Dtx9hZ0PmFM1BTonsUCTAdj2ZlQX5un8LCIbiUY/wuf7QYLBXq2t9VJcPBnVClSfB8qG2VJtklDIf+n7IAC17bmofpqn805gkbju8UzyWlNTSlHR28DjSTKqEVSnSVPT1+Z7DIAuWFDAxIk/AzfnAWAvPT3zpK3tQky3tnY8I0bMAW7C4/kLj2e3NDT8Evtn7FtWK2CykXiOiOtOGwJg20+huiUP57/S23uXtLb2xojJ5wuh+gIwYlBXVRHZBjwnrns2HpzJ2PQU+zPEdQ8MZMC2O1E1DJf9iMwTx9kZi8y296A6K4vCUcLhcmlp6deVK2+joOBHwJMAdKuEQk+LrlpVhshxRApyuD9BV9f1sn17RC1rMdCeCy8ia8RxArEg/f5ORBKDPEt3d5kB8Cgez8c5janGEMczdhTVO3PqwD/09Iwz9aK2XY/qa0k60Wi5qG2vRXV1HsbWiuu+EmfJU4jknCMxm6pTJRQ6qrb9BKofpHTEclHLMqk0Kc11/wFxnDVaUzOOoqKM7TfMiMh0cZxD6vc/hsiOlP+OAbATeCSXf6BZXLc2FpRl/ZmWZFKNmI4oLBwv69adUNtehmpbikhb/gBUv5RQqDxeA22oLssD9CFx3Vj7qWW9NYwPRN7J/wrgAtHoBGlq6lbLmgAYssk2piMUFEyXhobDWllZSGnpH8DYdFewBnh5WDSquxBZD6wCZsf/D12D3z87Tjgj02TiAiJV4jjvxjNWheqGNHJVmdtQda6EQrt1yZISxozZhepMRNrFcZZeMqS2fQOqdcD8eE2cRKQDaBTHMcSD1tdP5uLFI0A6oPeK1tVdRyRiqnqITo2myH76+sz87o+P6Wq6upoMEaW7ew0ESlIXDq2vn0Ik0oHquDTdcYa+vrIBKras/cADaQzvweudL8Hg+YSoR6O6F/gKeD3dRFTLGolqLSI24MtQrFvEdRcOAPD7n0RkawbB1eK6gwymtr0B1aq47HlEDJDvgdNEoz5EbgUM5XqzdonHc780Nh4cGseTJv2E6i0pSh2Ew/PMNQxmoLp6FF6vmW7/Z2s6LK57X+ymE1I7B9XdCQA68XorzL3GC/FFSkqaJRiMal3dtUQiB4Db8+CCZBGzkIiUi+t+kwQg3i6bUF0U0/B4HpLGxn2xue/1fgLMQuR9HOdZMQxvWeadsPEyALgSCpnaiJ3kndDsdIWFB4F7gO2otiDyUgIPGJ33AEOp6zIUbjZMHXR1VSR20vC1fOAlZNbyO/5zdNkVDgEVZktKFEv/MAkERnHunMnAg1cIxDa6u5dKe3vuh8lgUQ6sXctjqVa9+jKBnARqxHU3Z9LPuVTEmdLs8Wb6leYJpBvVN/F43hDHOZ1NJyeAwYwEAkWEww/HCy/5ea5qNqTfUP0u9vo5dqwzE2WngvkXkNUlwbIjKG0AAAAASUVORK5CYII="
                    style="width: 15px; height: 15px;"
                  />
                  <img
                    v-else
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAFN0lEQVRYR62Xa2wUVRTHf/8phbYQKCYFjH5A4iN+UBNREwExgBIiaGKiJEgFS7tbDSA+2C74SCkqttNGBUXsLgrII1gMRoNBECJCJL6ICR/wEUUSVBJU2oLSIu0cM+Nu2ZZtZyXcL5ude+7//Obce865I3Ic81fYgAEF3OXARMRoGSMNhgo8oNngsOBrz2Fn0VF21dSoIxdphRktSNrwAUYVUA4MCbNPzf8heP1MPi+/UqaWvtb0CmBmiq9mAfA8xsAcHfc0a8bhcbdC63pbnxUg3mhDPPGu4I4LdNxtmURTQT9m15SpvafeeQCxlTZC/dmBcf3FcN6lIfa1FTLt1VKdzNTtBhBttKJih08xbrqozlNiBjuLfmVq5gHtBhBP2nozSnN1LvgC2G9gCJNhlv4Fk4L//fGYAxT7ugYN9VHF0j66AOJv2N3m8EGuzn27wnyG1oScct8unrDnDJ5JAXSaMbahUj48AcD9TZZ3RQvfAlf9HwCB6xm7Hf2nIweZh0w0uxF9ntaKJe0pGS9kaO93oxrbBRBvtAdMbPw/zvuwbXYcJtVW6Js+ACCPiW65PgnI4wnbbX6Fy3UYHYh+WcxbnXzurC3TV34qm8O1fiSyRAATm+ojmqmFq2yY8vhNPlPvo1ViVYexVQUcapilvxevsJKzBYxzoNzgLsFfgil1Ue2vXmmD2vqz02BtfUSJbADAqeP5DNPChN3rwNZefYtteXnMeXGOfu/NJtZokx2jve5h7V3SaEWnHbZjjDdR2QcAnscYZZ7QLFVq8+FiSrdMV6c/V/WmXUMnk8wodsSPlsd2t1yn0uuq11hB2z9sQ0wKTnwIgIl5qkraWozZ572d+L7F48ZEpU4vfNsG6gwJGTPSmRPYiz8xFrhRBQc4lrDbBXvSWmEAQJ2qEvY+cE9PAMdhem2FtqRS9GNgQtYtEObBrIaINqQO9A6DyblEACORHUC0FP5CiV8yY6utQh7JkAQ5IWNUXaVa4wmbbvBOKkI1bkRLYo32msTcLFvc2NsWfOhGNS3Y96T5vWF8WIZKPFgX0YbYGhuhsxwL7I0OiQMGNwNOFo06H2ApxrM9JpNuVNEAIGHHgZJQAGNZXaWe9qt/VZJ/IGud6CkzN3saGuvcSj2UAjgKXB4GYA7V9RVaWt1k/dtaaQ/aU9gQt2rxW1bS2cFvPYj3uVEFYa9K2BbgvnCtoAjtSKXqdznYnzzdzrCAsippu7D/cjc1zjoDGV47U82xpN0m49Nu6ddD3eBQ0a9cV1Mjryppj2IsDwMANrpRlQYAsaTNkLEpc5HBs/VRPZ8CrMZY0ovoCU9MaIjoYHW19Wu7LOiqV4YBOGJCbUR7utrxqBYOGVydsfBUB9z0UlQ/+M8WJW2GZyzNEO8wsT1PPFFboR8D0EZ7GhFAh4zP3KjG+TbnLiSrbap5bOu2UHwP3OFG9Ev6+aJVNrIzj+Kz+RzJvHKnorievpuafyPqVCdj3Ef0ZTcA/088aevMmJUJITgmmFsb1XvZ3mr+ChtcUBCk8ZPKeKHeImDg1kcVT893S5XHm6wwv5U9GLdkETiI2CoL9rhVcKknxmHcC1wSFvNgXnz08xCmpZvbeRHwH6S+hHYAN+QkmquR2IvDtMzumRXAf1i9wQa3n2ZLuqnk6qMPu83H8ylbm8uHSZeI/2mWZB6wzGDQBUKcAB5zo/IPZ9YRWi6DStlJDCOSvtvnAHPcYKVjLPc7ZF/2oQDpxUGNb2FKcNsxRotzn+f+NVzwk8EB89h5ZCi7Mw9aXwD/AubEOUailtlcAAAAAElFTkSuQmCC"
                    alt=""
                    style="width: 16px; height: 16px;"
                  />
                </div> -->
                  <div
                    class="itemOne"
                    v-for="(item, index) in OutboundList"
                    :key="index"
                  >
                    <div class="outbound-right">
                      <div class="outbound-content mb10">
                        <img
                          src="data:image/png;base64,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"
                          style="width: 16px; height: 16px"
                        />
                        沟通时间：{{ item.outcall_createtime }}
                      </div>
                      <audioBox
                        v-if="item && activeName == 'sixed'"
                        :audioOneInfo="item"
                        :audioIndex="index"
                        @autoPlay="autoPlay"
                      ></audioBox>
                    </div>
                  </div>
                </div>
                <p v-else class="no-data pt30 pb30">
                  <i class="crm-wu"></i>
                  {{ $t("components.User.seeing.52b5hn58umo0") }}
                </p>
              </div>
            </el-tab-pane>
            <el-tab-pane
              :label="$t('User.tab_pane4')"
              name="fourth"
              v-if="
                (isRoot || isyhavetrack || bindRoot) &&
                UserInformation.client_tracestatus_status != '-1' &&
                UserInformation.client_tracestatus_status != '-2'
              "
            >
              <div class="slider-followUp">
                <el-form
                  ref="followForm"
                  :rules="followRules"
                  :model="followForm"
                  label-width="140px"
                >
                  <p class="form-small-title h3">{{ $t("User.s_title10") }}</p>

                  <img
                    v-if="showCallPhone"
                    @click="emitCallPhone(UserInformation)"
                    style="
                      width: 25px;
                      cursor: pointer;
                      position: absolute;
                      top: 50px;
                      right: 50px;
                      z-index: 10;
                    "
                    title="拨打电话"
                    src="data:image/png;base64,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"
                  />

                  <el-form-item
                    label="是否接通："
                    prop="client_answerphone"
                    key="client_answerphone"
                    v-if="!answerphoneDisabled"
                  >
                    <el-radio-group
                      v-model="followForm.client_answerphone"
                      :disabled="answerphoneDisabled"
                      @change="
                        followForm.track_answerphone =
                          followForm.client_answerphone == 1 ? '1' : '-1'
                      "
                    >
                      <el-radio label="0">未接通</el-radio>
                      <el-radio label="1">已接通</el-radio>
                    </el-radio-group>
                    <p
                      class="color-orange"
                      v-if="followForm.client_answerphone != 1"
                    >
                      已联系用户，但未接通(可右上角提交未接通跟进记录)
                    </p>
                  </el-form-item>

                  <el-form-item
                    label="本次接通状况："
                    prop="track_answerphone"
                    key="track_answerphone"
                    v-if="answerphoneDisabled"
                  >
                    <el-radio-group v-model="followForm.track_answerphone">
                      <el-radio label="-1">未接通</el-radio>
                      <el-radio label="1">已接通</el-radio>
                    </el-radio-group>
                    <p
                      class="color-orange"
                      v-if="followForm.track_answerphone != 1"
                    >
                      已联系用户，但未接通(可右上角提交未接通跟进记录)
                    </p>
                  </el-form-item>

                  <template
                    v-if="
                      (followForm.client_answerphone == '1' &&
                        !answerphoneDisabled) ||
                      (answerphoneDisabled && followForm.track_answerphone == 1)
                    "
                  >
                    <el-form-item
                      :label="$t('User.follow_label1')"
                      prop="track_linktype"
                      key="track_linktype"
                    >
                      <el-select
                        filterable
                        v-model="followForm.track_linktype"
                        style="width: 340px"
                        :placeholder="$t('User.follow_placeholder1')"
                      >
                        <el-option
                          v-for="items in CommodeData"
                          :key="items.commode_id"
                          :label="items.commode_name"
                          :value="items.commode_name"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      :label="$t('User.follow_label2')"
                      prop="object_code"
                      key="object_code"
                    >
                      <el-select
                        filterable
                        v-model="followForm.object_code"
                        style="width: 340px"
                        :placeholder="$t('User.follow_placeholder2')"
                      >
                        <el-option
                          v-for="items in ObjectData"
                          :key="items.object_code"
                          :label="items.object_name"
                          :value="items.object_code"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <!-- <el-form-item
                    :label="$t('User.follow_label3')"
                    prop="track_validinc"
                    key="track_validinc"
                  >
                    <el-radio-group v-model="followForm.track_validinc">
                      <el-radio label="1">{{
                        $t("User.follow_options1[0]")
                      }}</el-radio>
                      <el-radio label="2">{{
                        $t("User.follow_options1[1]")
                      }}</el-radio>
                    </el-radio-group>
                  </el-form-item> -->
                    <el-form-item
                      :label="$t('User.follow_label4')"
                      prop="track_intention_level"
                      key="track_intention_level"
                    >
                      <!-- <el-rate
                        @change="validateRete"
                        v-model="followForm.track_intention_level"
                        show-text
                        class="rate-startLevel rate-startLevel-diy"
                        :texts="intentionLevelList"
                        :icon-classes="['crm-likes', 'crm-likes', 'crm-likes']"
                        void-icon-class="crm-like"
                        :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
                      ></el-rate> -->
                      <div
                        class="flex items-center mb5"
                        v-if="
                          UserInformation.client_intention_level &&
                          UserInformation.client_intention_level > 0
                        "
                      >
                        <span class="fs14">上次意向星级：</span>
                        <div class="flex items-center">
                          <span
                            class="fs20 crm-likes"
                            v-for="(icon, iconIndex) in Number(
                              UserInformation.client_intention_level
                            )"
                            :key="iconIndex"
                          ></span>
                        </div>
                      </div>
                      <el-radio-group
                        v-model="followForm.track_intention_level"
                        size="small"
                      >
                        <div
                          class="mb10"
                          v-for="(item, index) in intentionLevelList"
                          :key="index"
                        >
                          <el-radio :label="`${index + 1}`" border>
                            <div>
                              <div class="flex items-center mb5">
                                <span
                                  class="fs20 crm-likes"
                                  v-for="(icon, iconIndex) in index + 1"
                                  :key="iconIndex"
                                ></span>
                              </div>
                              <p
                                class="mb5"
                                style="font-size: 14px; color: #000"
                              >
                                {{ item.intentlevel_remark }}
                              </p>
                              <p style="font-size: 12px; color: #999">
                                {{ item.intentlevel_describe }}
                              </p>
                            </div>
                          </el-radio>
                        </div>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item
                      :label="$t('User.follow_label5')"
                      prop="track_followmode"
                      key="track_followmode"
                    >
                      <el-radio-group
                        v-model="followForm.track_followmode"
                        @change="sourceFilter"
                        class="type-follow"
                      >
                        <el-radio label="1">{{
                          $t("User.follow_options2[0]")
                        }}</el-radio>
                        <el-radio label="2">{{
                          $t("User.follow_options2[1]")
                        }}</el-radio>
                        <el-radio label="0">{{
                          $t("User.follow_options2[2]")
                        }}</el-radio>
                        <el-radio
                          v-if="
                            UserInformation.client_tracestatus_status != '4' &&
                            !(
                              UserInformation.isgmcIndschoolenter == 1 &&
                              UserInformation.isgmcschoolenter != 1
                            ) &&
                            companyIsNoIntention
                          "
                          label="-1"
                          >{{ $t("User.follow_options2[3]") }}</el-radio
                        >
                        <el-radio
                          v-if="
                            UserInformation.client_tracestatus_status != '4' &&
                            !(
                              UserInformation.isgmcIndschoolenter == 1 &&
                              UserInformation.isgmcschoolenter != 1
                            )
                          "
                          label="-2"
                          >{{ $t("User.follow_options2[4]") }}</el-radio
                        >
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item
                      prop="coursetype_id"
                      key="coursetype_id1"
                      :rules="[
                        {
                          required:
                            UserInformation.company_ismusttrackcoursetype == 1,
                          message: $t(
                            'views.Analysisreport.admTrackReport.51yzwntm4j40'
                          ),
                          trigger: ['change', 'blur'],
                        },
                      ]"
                      :label="$t('User.follow_label166')"
                      v-if="
                        (followForm.track_followmode == '1' ||
                          followForm.track_followmode === '0' ||
                          followForm.track_followmode == '-1') &&
                        UserInformation.company_istrackcoursetype == 1
                      "
                    >
                      <el-select
                        style="width: 340px"
                        v-model="followForm.coursetype_id"
                        clearable
                        filterable
                        :placeholder="
                          $t('views.Analysisreport.admTrackReport.51yzwntm4j40')
                        "
                        @change="filterCourseCat"
                      >
                        <el-option
                          v-for="(item, index) in filterList.coursetypeList"
                          :key="index"
                          :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                          :value="item.coursetype_id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      prop="coursecat_id"
                      key="coursecat_id1"
                      :rules="[
                        {
                          required:
                            UserInformation.company_ismusttrackcoursetype == 1,
                          message: $t('User.ah'),
                          trigger: ['change', 'blur'],
                        },
                      ]"
                      :label="$t('User.ag')"
                      v-if="
                        (followForm.track_followmode == '1' ||
                          followForm.track_followmode === '0') &&
                        UserInformation.company_istrackcoursetype == 1
                      "
                    >
                      <el-select
                        style="width: 340px"
                        v-model="followForm.coursecat_id"
                        clearable
                        filterable
                        :placeholder="$t('User.ah')"
                      >
                        <el-option
                          v-for="(item, index) in filterList.courseCatList"
                          :key="index"
                          :label="`${item.coursecat_cnname}(${item.coursecat_branch})`"
                          :value="item.coursecat_id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      v-if="followForm.track_followmode == '2'"
                      :label="$t('User.follow_label6')"
                      :rules="[
                        {
                          required: true,
                          message: '请选择中试听类型',
                          trigger: ['change', 'blur'],
                        },
                      ]"
                      prop="audition_genre"
                      key="audition_genre"
                    >
                      <el-select
                        filterable
                        clearable
                        v-model="followForm.audition_genre"
                        style="width: 340px"
                        :placeholder="$t('User.follow_placeholder6')"
                        @change="ClickAudition()"
                      >
                        <!-- <el-option
                      :label="$t('User.follow_options3[0]')"
                      value="0"
                    ></el-option>
                    <el-option
                      :label="$t('User.follow_options3[1]')"
                      value="1"
                    ></el-option> -->
                        <el-option
                          v-for="(item, index) in auditionTypesList"
                          :key="index"
                          :label="item.name"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      v-if="
                        followForm.track_followmode == '1' ||
                        followForm.track_followmode == '2'
                      "
                      :label="$t('User.follow_label7')"
                      prop="receiver_name"
                      key="receiver_name"
                    >
                      <el-select
                        filterable
                        v-model="followForm.receiver_name"
                        style="width: 340px"
                        :placeholder="$t('User.follow_placeholder7')"
                      >
                        <el-option
                          v-for="items in ReceiverList"
                          :key="items.marketer_id"
                          :label="items.marketer_name"
                          :value="items.marketer_name"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      v-if="followForm.track_followmode == '1'"
                      :label="$t('User.follow_label8')"
                    >
                      <el-select
                        filterable
                        v-model="followForm.invite_genre"
                        style="width: 340px"
                        :placeholder="$t('User.follow_placeholder8')"
                      >
                        <el-option
                          :label="item.genre_reason"
                          :value="item.genre_id"
                          v-for="(item, index) in inviteGenreList"
                          :key="index"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      v-if="followForm.track_followmode == '1'"
                      prop="invite_visittime"
                      :label="$t('User.follow_label9')"
                      key="invite_visittime"
                    >
                      <el-date-picker
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :placeholder="$t('User.follow_placeholder9')"
                        v-model="followForm.invite_visittime"
                        style="width: 340px"
                      ></el-date-picker>
                    </el-form-item>
                    <el-form-item
                      v-if="followForm.track_followmode == '2'"
                      prop="audition_visittime"
                      :label="$t('User.follow_label10')"
                      key="audition_visittime"
                    >
                      <el-date-picker
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :placeholder="$t('User.follow_placeholder10')"
                        v-model="followForm.audition_visittime"
                        @change="ClickAuditiontime()"
                        style="width: 340px"
                      ></el-date-picker>
                    </el-form-item>

                    <el-form-item
                      v-if="followForm.track_followmode == '2'"
                      :label="$t('User.follow_label11')"
                      prop="className"
                      :rules="[
                        {
                          required: !followForm.class_cnname,
                          message: '请选择试听班级',
                          trigger: ['blur', 'change'],
                        },
                      ]"
                      key="className"
                    >
                      <!-- <el-form-item v-if="followForm.track_followmode=='2'" prop="class_id" label="试听班级："> -->
                      <el-input
                        type="text"
                        :disabled="followForm.audition_genre === ''"
                        style="width: 340px"
                        @focus="leaning()"
                        @click="leaning()"
                        :placeholder="$t('User.follow_placeholder11_1')"
                        v-model="followForm.className"
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      v-if="followForm.track_followmode == '2'"
                      label=""
                      prop="class_cnname"
                      :rules="[
                        {
                          required: !followForm.className,
                          message: '请选择试听班级',
                          trigger: ['blur', 'change'],
                        },
                      ]"
                      key="class_cnname"
                    >
                      <el-input
                        type="text"
                        :disabled="followForm.audition_genre === ''"
                        style="width: 340px; margin-top: -15px"
                        :placeholder="$t('User.follow_placeholder11_2')"
                        v-model="followForm.class_cnname"
                      ></el-input>
                      <el-input
                        type="hidden"
                        style="width: 0px"
                        @focus="leaning()"
                        @click="leaning()"
                        :placeholder="$t('User.follow_placeholder11_1')"
                        v-model="followForm.class_id"
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      :label="$t('User.follow_label166')"
                      v-if="
                        followForm.track_followmode === '2' &&
                        UserInformation.company_istrackcoursetype == 1
                      "
                      :rules="[
                        {
                          required:
                            UserInformation.company_ismusttrackcoursetype == 1,
                          message: $t(
                            'views.Analysisreport.admTrackReport.51yzwntm4j40'
                          ),
                          trigger: ['change', 'blur'],
                        },
                      ]"
                      prop="coursetype_id"
                      key="coursetype_id2"
                    >
                      <el-select
                        style="width: 340px"
                        v-model="followForm.coursetype_id"
                        clearable
                        filterable
                        :placeholder="
                          $t('views.Analysisreport.admTrackReport.51yzwntm4j40')
                        "
                        :disabled="
                          (followForm.audition_genre == '1' &&
                            !!followForm.className) ||
                          followForm.audition_genre === ''
                        "
                        @change="filterCourseCat"
                      >
                        <el-option
                          v-for="(item, index) in filterList.coursetypeList"
                          :key="index"
                          :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                          :value="item.coursetype_id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      prop="coursecat_id"
                      key="coursecat_id2"
                      :rules="[
                        {
                          required:
                            UserInformation.company_ismusttrackcoursetype == 1,
                          message: $t('User.ah'),
                          trigger: ['change', 'blur'],
                        },
                      ]"
                      :label="$t('User.ag')"
                      v-if="
                        followForm.track_followmode === '2' &&
                        UserInformation.company_istrackcoursetype == 1
                      "
                    >
                      <el-select
                        style="width: 340px"
                        v-model="followForm.coursecat_id"
                        clearable
                        filterable
                        :placeholder="$t('User.ah')"
                        :disabled="
                          (followForm.audition_genre == '1' &&
                            !!followForm.className) ||
                          followForm.audition_genre === ''
                        "
                      >
                        <el-option
                          v-for="(item, index) in filterList.courseCatList"
                          :key="index"
                          :label="`${item.coursecat_cnname}(${item.coursecat_branch})`"
                          :value="item.coursecat_id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      v-if="followForm.track_followmode == '3'"
                      :label="$t('User.follow_label12')"
                    >
                      <el-date-picker
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :placeholder="$t('User.follow_placeholder12')"
                        v-model="followForm.audition_visittime"
                        style="width: 340px"
                      ></el-date-picker>
                    </el-form-item>
                    <el-form-item
                      v-if="followForm.track_followmode == '-1'"
                      :label="$t('User.follow_label13')"
                    >
                      <el-select
                        filterable
                        v-model="followForm.invite_genre"
                        style="width: 340px"
                        :placeholder="$t('User.follow_placeholder13')"
                      >
                        <el-option
                          :label="$t('User.follow_options5[0]')"
                          value="0"
                        ></el-option>
                        <el-option
                          :label="$t('User.follow_options5[1]')"
                          value="1"
                        ></el-option>
                        <el-option
                          :label="$t('User.follow_options5[2]')"
                          value="2"
                        ></el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item
                      v-if="followForm.track_followmode == -2"
                      label="无效原因："
                      prop="invalidnote_code"
                    >
                      <el-select
                        filterable
                        v-model="followForm.invalidnote_code"
                        style="width: 340px"
                        placeholder="请选择无效原因"
                      >
                        <el-option
                          v-for="items in invalidNoteList"
                          :key="items.invalidnote_code"
                          :label="items.invalidnote_reason"
                          :value="items.invalidnote_code"
                        ></el-option>
                      </el-select>
                      <p class="color-orange">
                        仅可选择以上无效原因，无效名单提交后需经过审批
                      </p>
                    </el-form-item>

                    <el-form-item
                      :label="$t('User.ai')"
                      v-if="followForm.track_followmode != -2"
                    >
                      <el-select
                        filterable
                        v-model="checkList"
                        style="width: 340px"
                        :placeholder="$t('User.ak')"
                        @change="handClickModel()"
                      >
                        <el-option
                          v-for="items in TraceNoteData"
                          :key="items.tracenote_code"
                          :label="items.tracenote_remk"
                          :value="items.tracenote_remk"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      :label="$t('User.aj')"
                      :prop="
                        followForm.track_followmode == -2 ? '' : 'track_note'
                      "
                      :key="
                        followForm.track_followmode == -2
                          ? 'invalidnote_code'
                          : 'track_note'
                      "
                    >
                      <el-input
                        type="textarea"
                        style="width: 340px"
                        :placeholder="$t('User.follow_placeholder14_2')"
                        v-model="followForm.track_note"
                      ></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('User.follow_label15')">
                      <el-select
                        filterable
                        v-model="followForm.track_followuptype"
                        style="width: 340px"
                        :placeholder="$t('User.follow_placeholder15')"
                      >
                        <el-option
                          :label="$t('User.follow_options6[0]')"
                          value="0"
                        ></el-option>
                        <el-option
                          :label="$t('User.follow_options6[1]')"
                          value="1"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      v-if="followForm.track_followuptype == '1'"
                      :label="$t('User.follow_label16')"
                    >
                      <el-date-picker
                        type="date"
                        :placeholder="$t('User.follow_placeholder16')"
                        value-format="yyyy-MM-dd"
                        v-model="followForm.track_followuptime"
                        :picker-options="pickerOptions"
                        style="width: 340px"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </template>

                  <template
                    v-if="
                      followForm.client_answerphone == 0 ||
                      followForm.track_answerphone == -1
                    "
                  >
                    <el-form-item :label="$t('User.follow_label15')">
                      <el-select
                        filterable
                        v-model="followForm.track_followuptype"
                        style="width: 340px"
                        :placeholder="$t('User.follow_placeholder15')"
                      >
                        <el-option
                          :label="$t('User.follow_options6[0]')"
                          value="0"
                        ></el-option>
                        <el-option
                          :label="$t('User.follow_options6[1]')"
                          value="1"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      v-if="followForm.track_followuptype == '1'"
                      :label="$t('User.follow_label16')"
                    >
                      <el-date-picker
                        type="date"
                        :placeholder="$t('User.follow_placeholder16')"
                        value-format="yyyy-MM-dd"
                        v-model="followForm.track_followuptime"
                        :picker-options="pickerOptions"
                        style="width: 340px"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </template>
                </el-form>

                <p class="form-small-title h3">{{ $t("User.s_title11") }}</p>
                <el-row
                  v-for="(items, index) in currentrecordData"
                  :key="index"
                >
                  <el-col :span="4">
                    <div class="grid-content bg-purple grid-content-img">
                      <img
                        v-if="
                          items.marketer_img != '' && items.marketer_img != null
                        "
                        :src="items.marketer_img"
                      />
                      <img
                        v-else-if="
                          items.staffer_sex ==
                          $t('components.User.seeing.52b5hn58u240')
                        "
                        :src="photoImgWomen"
                      />
                      <img v-else :src="photoImgmen" />
                    </div>
                  </el-col>
                  <el-col :span="20">
                    <div class="grid-content bg-purple-light text-1">
                      <p class="clearFloat">
                        {{ items.marketer_name }}
                        <span
                          v-if="items.track_linktype != ''"
                          class="btn-purple font-gray"
                          >{{ items.track_linktype }}</span
                        >
                        <span
                          v-if="items.track_followcont != ''"
                          class="btn-purple font-gray"
                          >{{ items.track_followcont }}</span
                        >
                        <span class="font-gray show-time pull-right">{{
                          items.track_createtime
                        }}</span>
                      </p>
                      <p>
                        {{ $t("User.follow_label2") }}{{ items.object_name }}
                      </p>
                      <p v-if="items.track_followmode == '2'">
                        {{ $t("User.tryDate") }}{{ items.track_visitingtime }}
                      </p>
                      <p v-if="items.track_followmode == '2'">
                        {{ $t("User.tryClass") }}{{ items.class_cnname }}
                      </p>
                      <p v-if="items.track_followmode == '1'">
                        {{ $t("User.guiDate") }}{{ items.track_visitingtime }}
                      </p>
                      <p
                        v-if="
                          items.track_followuptime &&
                          items.track_followuptime != ''
                        "
                      >
                        {{ $t("User.nextFollowDate")
                        }}{{ items.track_followuptime }}
                      </p>
                      <div class="flex-all" style="line-height: 28px">
                        <p>
                          {{ $t("User.followSchool") }}
                          {{ items.school_cnname }}
                        </p>
                        <p
                          v-if="items.track_isreading == '1'"
                          class="text-3 mb10"
                        >
                          {{ items.level_marketer_name }}
                          <span class="font-gray"
                            >{{ $t("User.label_text20")
                            }}{{ items.track_readtime
                            }}{{ $t("User.btn_text4") }}</span
                          >
                        </p>
                      </div>
                      <!-- 沟通内容 -->
                      <div class="communite-cont mb20">
                        <p>
                          <span>{{ $t("User.communiteContent") }}</span>
                          <span
                            class="font-red"
                            v-if="items.track_note == '未接通'"
                            >未接通</span
                          >
                          <span v-else>{{ items.track_note }}</span>
                        </p>
                        <div
                          v-if="
                            postbe_crmlevel == '1' &&
                            items.track_isactive == '1'
                          "
                          class="btns"
                        >
                          <el-button
                            v-if="items.track_isreading == '0'"
                            type="warning"
                            @click="handRead(items, index)"
                          >
                            {{ $t("User.btn_text4") }}</el-button
                          >
                          <el-button
                            v-else
                            type="warning"
                            disabled
                            class="btn-disabled"
                            >{{ $t("User.btn_text5") }}
                          </el-button>
                          <el-button
                            type="primary"
                            v-if="!items.isClickReply"
                            :disabled="items.replay_id > 0"
                            :class="{ 'btn-disabled': items.replay_id > 0 }"
                            @click="handReply(items, index)"
                          >
                            {{ $t("User.btn_text6") }}</el-button
                          >
                        </div>
                      </div>
                      <!-- 回复内容 -->
                      <!-- 回复弹框 -->
                      <div
                        v-if="postbe_crmlevel == '1' && items.isClickReply"
                        class="communite-replay mb20"
                      >
                        <div class="img mt20 mb10">
                          <img
                            v-if="
                              items.login_marketer_img != '' &&
                              items.login_marketer_img != null
                            "
                            :src="items.login_marketer_img"
                          />
                          <img
                            v-else-if="
                              items.login_marketer_sex ==
                              $t('components.User.seeing.52b5hn58u240')
                            "
                            :src="photoImgWomen"
                          />
                          <img v-else :src="photoImgmen" />
                        </div>
                        <div class="replay-cont">
                          <div class="replay-top mt20 mb10">
                            <span>
                              {{ items.login_marketer_name }}
                              <span class="font-gray ml5 mr5">{{
                                $t("User.btn_text6")
                              }}</span>
                              {{ items.marketer_name }}
                            </span>
                            <div class="btns">
                              <el-button
                                type="primary"
                                @click="levelReplayTrackAction(items, index)"
                              >
                                {{ $t("Common.btn_confirm") }}</el-button
                              >
                              <el-button
                                plain
                                @click="handCloseReply(items, index)"
                                >{{ $t("Common.btn_cancel") }}
                              </el-button>
                            </div>
                          </div>
                          <el-input
                            type="textarea"
                            rows="3"
                            style="width: 485px"
                            :placeholder="$t('User.replay_placeholder')"
                            v-model="items.replay_note"
                          ></el-input>
                        </div>
                      </div>
                      <!-- 回复列表 -->
                      <div
                        v-if="items.replay_info && items.replay_info.length > 0"
                        class="replay-list"
                      >
                        <div
                          v-for="(item1, index1) in items.replay_info"
                          :key="index1"
                          class="communite-replay"
                        >
                          <div class="img mt20 mb10">
                            <img
                              v-if="
                                item1.marketer_img != '' &&
                                item1.marketer_img != null
                              "
                              :src="item1.marketer_img"
                            />
                            <img
                              v-else-if="
                                item1.staffer_sex ==
                                $t('components.User.seeing.52b5hn58u240')
                              "
                              :src="photoImgWomen"
                            />
                            <img v-else :src="photoImgmen" />
                          </div>
                          <div class="replay-cont">
                            <div class="replay-top mt20 mb10">
                              <span>
                                {{ item1.marketer_name }}
                                <span class="font-gray ml5 mr5">{{
                                  $t("User.btn_text6")
                                }}</span>
                                {{ items.marketer_name }}
                              </span>
                              <span class="font-gray">{{
                                item1.replay_createtime
                              }}</span>
                            </div>
                            <p>{{ item1.replay_note }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
                <p v-if="recordDatalen == '0'" class="no-data pt30 pb30">
                  <i class="crm-wu"></i>
                  {{ $t("User.noFollowRecord2") }}
                </p>
              </div>
            </el-tab-pane>
            <!-- // company_ismajor  0是免费版 1是普通版   2是专业版 -->
            <el-tab-pane
              v-if="companyIsmajor == '2'"
              :label="`${$t('User.tab_pane5')}(${UserInformation.bind_num})`"
              name="fives"
            >
              <div class="slider-studentBind">
                <p class="form-small-title h3">{{ $t("User.s_title1") }}</p>
                <el-row v-for="(item, index) in BindingInfor" :key="index">
                  <!-- FriendRelation -->
                  <el-col :span="24">
                    <div class="person-img pull-left">
                      <!-- <img :src="item.client_img"> -->
                      <img
                        v-if="item.client_img != ''"
                        :src="item.client_img"
                      />
                      <img
                        v-else-if="item.client_sex == '男'"
                        src="@/assets/images/default-img-man.png"
                        alt=""
                      />
                      <img
                        v-else-if="item.client_sex == '女'"
                        src="@/assets/images/default-img-women.png"
                        alt=""
                      />
                      <!-- <img
                      v-if="item.client_img == ''"
                      src="@/assets/images/default-img.png"
                    /> -->
                    </div>
                    <div class="person-information pull-left">
                      <div class="person-name">
                        {{ item.client_cnname }}
                        <img
                          v-if="
                            item.client_sex ==
                            $t('components.User.seeing.52b5hn58uuk0')
                          "
                          :src="iconmen"
                          class="icon-person-sex"
                        />
                        <img v-else :src="iconWommen" class="icon-person-sex" />
                        <!-- <img src="../../assets/images/icon/icon-sex-man.png" class="icon-person-sex"> -->
                      </div>
                      <p>
                        {{ item.client_age }}{{ $t("Common.age") }}
                        <span class="phone">{{ item.client_mobile }}</span>
                      </p>
                      <p>
                        {{ $t("User.BindShip")
                        }}{{ item.binding_friend_relation }}
                      </p>
                      <template
                        v-if="
                          item.client_tracestatus != '-1' &&
                          item.client_tracestatus != '-2'
                        "
                      >
                        <el-button
                          v-if="!isnotBiding"
                          type="primary"
                          @click="ClickFloow(item)"
                          >{{ $t("User.btn_text3") }}
                        </el-button>
                        <el-button
                          v-if="isnotBiding"
                          type="primary"
                          class="btn-biding-disable"
                          >{{ $t("User.btn_text3") }}
                        </el-button>
                      </template>
                      <template v-else>
                        <el-button type="primary" class="btn-biding-disable">{{
                          $t("User.btn_text3")
                        }}</el-button>
                      </template>
                    </div>
                  </el-col>
                </el-row>
                <p v-if="BindingInforlen == '0'" class="no-data pt30 pb30">
                  <i class="crm-wu"></i>
                  {{ $t("User.noBindRecord") }}
                </p>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <!-- 试听班级 -->
    <div>
      <!-- 跟班试听 中间-->
    </div>
    <!-- 添加标签的弹框 -->
    <addTapPop
      v-if="addTagVisable"
      :newclientTags="newclientTag"
      :clientId="clientId"
      :dialogVisable="addTagVisable"
      :defautLabelList="UserInformation.client_tag"
      labelType="0"
      @handleCloseTip="addTagVisable = false"
      @handCancel="addTagVisable = false"
      @handConfirm="handConfirm"
    ></addTapPop>

    <el-dialog
      title="补充备注"
      :visible.sync="addTrackVisible"
      width="550px"
      :before-close="handleClose"
      append-to-body
    >
      <p class="fs14 color-333">该功能用于为无权限跟进的撞单名单补充备注信息，此操作不计入主动跟进记录。若名单仍属当前校区，请在【意向客户】模块中进行后续跟进。</p>
      <el-form :model="addTrackForm" ref="addTrackForm" label-width="100px">
        <el-form-item
          label="补充内容："
          prop="track_note"
          :rules="[
            {
              required: true,
              message: '请输入补充内容',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            type="textarea"
            rows="5"
            placeholder="请输入补充内容"
            v-model="addTrackForm.track_note"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleAddTrackConfirm">
          {{ $t("Customersmanage.av") }}
        </el-button>
        <el-button @click="addTrackVisible = false"> 取消 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import tipsTable from "../Table/tipsTable";
import audioBox from "../common/audioBox";
// import storeanalysisreport from "@/views/Analysisreport/analysisreport.js";
import addTapPop from "./addTapPop";
import storeUser from "./User.js";
export default {
  name: "userSeeing",
  props: [
    "fromType",
    "showUserSliderBox",
    "createJG",
    "customerId",
    "isRoot",
    "isTrack",
    "iscanEdit",
    "seeSliderTitle",
    "isForm",
    "isHome",
    "isshowfirst",
    "ClassMessage",
    "isnotBiding", //不可绑定学员
    // "recordoptions",
    // "recordlistColumn",
    // "recordOperates",
    // "tryClasslist",
    // "Classoptions",
    // "ClasslistColumn",
    // "ClassOperates",
    // "CommodeData",
    // "BindingInfor",
    // "TraceNoteData",
    // "currentrecordData",
    "refreshInfo", // 重新获取基本信息
    "newclientTags",
    "showCallPhone",
    "showAddTrack",
  ],
  data() {
    let trackIntentionLevel = (rule, value, callback) => {
      (() => {})(value, "value");
      if (!value || value == 0 || value == "0") {
        return callback(new Error("请选择意向星级"));
      } else {
        callback();
      }
    };
    return {
      addTrackVisible: false,
      addTrackForm: {
        track_note: "",
      },

      currentId: -1,
      filtersOption: [
        { label: "全部动态", value: 0, id: -1 },
        { label: "跟进记录", value: 0, id: 1 },
        { label: "操作日志", value: 0, id: 0 },
      ],

      invalidNoteList: [],
      inviteGenreList: [],
      answerphoneDisabled: false,
      filterList: {
        coursetypeList: "",
        courseCatList: "",
      },
      newclientTag: [],
      clientId: "",

      auditionTypesList: [],
      addTagVisable: false, //添加标签
      // 渠道变更记录
      channelChangeList: [],
      // 跟进
      followForm: {
        client_id: "",
        coursetype_id: "",
        coursecat_id: "",
        track_linktype: "",
        client_answerphone: "",
        track_answerphone: "-1",
        track_validinc: "",
        track_intention_level: 0,
        track_followuptype: "",
        track_followuptime: "",
        track_followmode: "", //本次跟进模式0普通回访1柜询2试听3转正-1跟进无意向
        // track_note_temp: "", //沟通模板不需要传
        track_note: "",
        class_id: "",
        class_cnname: "",
        className: "",
        invite_genre: "", //邀约柜询类型 邀约类型 变量 0普通柜询1能力测试
        client_lapsedtype: "", //无意向类型 0已报异业1强烈抵触2其他
        object_code: "", //沟通对象
        audition_genre: "", //试听类型
        receiver_name: "", //接待人

        invalidnote_code: "",
        invalidnote_reason: "",
      },
      intentionLevelList: [], //意向星级注释列表
      activeName: "first",
      isClickBand: false,
      fllow_id: "",
      num: null,
      maxNum: null,
      //判断是否有数据
      recordDatalen: "",
      BindingInforlen: "",
      moreVisible: false,
      isyhavetrack: false,
      isyhavetrackedit: false,
      isRoottrack: false,
      bindRoot: false, //绑定学员跟进
      clientLevelNum: null, //意向星级
      tabEdit: true, //tab切换编辑权限
      checkList: "",
      iconWommen: require("../../assets/images/icon/icon-person-women.png"),
      iconmen: require("../../assets/images/icon/icon-person-men.png"),
      photoImgWomen: require("../../assets/images/default-staff-women.png"), //默认女头像
      photoImgmen: require("../../assets/images/default-staff-men.png"), //默认男头像
      //获取数据
      UserInformation: [], //用户基本信息
      // 跟踪记录
      recordData: [],
      currentrecordData: [], //最近跟踪记录
      oneTrackInfo: {}, //单个跟踪记录信息
      OutboundList: [], //外拨记录列表
      //柜询记录
      recordcolumnWidth: ["150", "150", "250", "auto"],
      tryRecordlist: [],
      recordlistColumn: [],
      recordoptions: {
        mutiSelect: false, // 是否支持列表项选中功能
        highlightCurrentRow: true, // 是否支持当前行高亮显示
        errortip: "",
      },
      recordOperates: {
        width: 200,
        label: this.$t("Common.operatesLabel"),
        align: "center",
        fixed: "right",
        list: [],
      },
      //试听课程表格开始
      ClasscolumnWidth: ["auto", "150", "150", "150", "150", "150"],
      ClassId: "",
      CourseId: "",
      HourId: "",
      tryClasslist: [],
      ClasslistColumn: [],
      Classoptions: {
        mutiSelect: false, // 是否支持列表项选中功能
        highlightCurrentRow: true, // 是否支持当前行高亮显示
        errortip: "",
      },
      ClassOperates: {
        width: 200,
        label: this.$t("Common.operatesLabel"),
        align: "center",
        fixed: "right",
        list: [],
      },
      CommodeData: [], //获取沟通类型
      ObjectData: [], //获取沟通对象
      ReceiverList: [], //接待人->获取有接待权限的接待人
      BindingInfor: [],
      TraceNoteData: [], //沟通模板
      // 跟进校验规则
      followRules: {
        client_answerphone: [
          {
            required: true,
            message: "请选择是否接通",
          },
        ],
        invalidnote_code: [
          {
            required: true,
            message: "请选择无效原因",
          },
        ],
        track_answerphone: [
          {
            required: true,
            message: "请选择是否接通",
          },
        ],
        track_linktype: [
          {
            required: true,
            message: "请选择沟通类型",
            trigger: ["blur", "change"],
          },
        ],
        object_code: [
          {
            required: true,
            message: "请选择沟通对象",
            trigger: ["blur", "change"],
          },
        ],
        track_validinc: [
          {
            required: true,
            message: "请选择沟通效果",
            trigger: ["blur", "change"],
          },
        ],
        track_intention_level: [
          {
            required: true,
            validator: trackIntentionLevel,
            trigger: ["change", "blur"],
          },
        ],
        track_followmode: [
          {
            required: true,
            message: "请选择跟进类型",
            trigger: ["blur", "change"],
          },
        ],
        receiver_name: [
          {
            required: true,
            message: this.$t("User.follow_rule1"),
            trigger: ["blur", "change"],
          },
        ],
        class_id: [
          {
            required: true,
            message: this.$t("User.follow_rule2"),
            trigger: ["blur", "change"],
          },
        ],
        invite_visittime: [
          {
            required: true,
            message: this.$t("User.follow_rule3"),
            trigger: ["blur", "change"],
          },
        ],
        audition_visittime: [
          {
            required: true,
            message: this.$t("User.follow_rule4"),
            trigger: ["blur", "change"],
          },
        ],

        track_note: [
          {
            required: true,
            message: this.$t("User.follow_rule5"),
            trigger: ["blur", "change"],
          },
        ],
      },
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < Date.now();
        },
      },
    };
  },
  components: {
    tipsTable,
    audioBox,
    addTapPop,
  },
  created() {
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    // 权限判断
    this.postbe_crmlevel = this.$store.state.POSTBE_CRMLEVEL;
    this.Userinfomation = this.$store.state.USER_INFO;
    // this.activeName = "first";
    this.bindRoot = false; //初始化
    this.getIntentionLevelList();
    if (this.isTrack) {
      this.activeName = "fourth";
      this.isRoottrack = true;
      this.getclientOneTrackData();
      this.getCommodeData();
      this.getReceiverList();
      this.getObjectApi();
      this.getTraceNoteData();
    } else {
      this.isRoottrack = false;
      this.activeName = "first";
      // this.getclientOneData(this.customerId);
    }
    if (this.isHome) {
      this.activeName = "first";
      // this.getclientOneData(this.customerId);
      this.isRoottrack = false;
    }

    this.isClickBand = false;
    //获取数据
    this.getSourceData();
    this.getMarketer();
    this.getIntentCourseData();
    // this.getCommodeData();
    // this.getTraceNoteData();
    this.getclientOneData(this.customerId);
    this.getChannelTrack(this.customerId);

    if (this.ClassMessage.class_cnname) {
      this.followForm.className = this.ClassMessage.class_cnname;
      this.followForm.class_cnname = this.followForm.className;
    }

    // this.followForm.audition_visittime=this.ClassMessage.hour_day;
    // this.getclientOneTrackData(this.customerId);
    // this.getBindingClientData(this.customerId);
    // this.getclientOneInviteData(this.customerId);
    // this.getclientOneAuditionData(this.customerId);
    // this.recordDatalen = this.recordData.length;
    // this.BindingInforlen = this.BindingInfor.length;
    // this.num = parseInt(this.UserInformation.client_intention_level);

    this.getAuditionTypesApi();
    this.clientId = this.customerId;
    this.newclientTag = this.newclientTags;
    this.courseTypeRecruitApi();
    this.getTypeCourseCatApi();
    this.getInviteGenreApi();
    this.getInvalidnoteApi();
  },
  watch: {
    refreshInfo(n) {
      if (n) {
        this.getclientOneData(this.customerId);
        this.$emit("changeRefreshInfoStatus");
      }
    },
    //用户信息监听
    ClassMessageinfo(n) {
      (() => {})(n, 1111122221);
      this.ClassId = n.class_id;
      this.CourseId = n.course_id;
      this.HourId = n.hour_id;

      if (n.class_cnname) {
        this.followForm.class_id = n.class_cnname;
        this.followForm.className = n.class_cnname;
        this.followForm.class_cnname = this.followForm.className;
      }
      if (this.followForm.audition_genre == 1) {
        this.followForm.coursetype_id = n.coursetype_id;
        this.filterCourseCat();
        this.followForm.coursecat_id = n.coursecat_id;
      } else {
        this.followForm.coursetype_id = "";
        this.followForm.coursecat_id = "";
      }
      let classHourTime = n.hour_time.split("-")[0] + ":00";
      (() => {})(this.getDate(n.hour_day, classHourTime), "时间");
      this.$set(
        this.followForm,
        "audition_visittime",
        this.getDate(n.hour_day, classHourTime)
      );
    },
    // id监听
    getcustomerId(n) {
      this.fllow_id = n;
      this.getclientOneData(n);
      this.getCommodeData();
      this.getReceiverList();
      this.getObjectApi();
      this.getTraceNoteData();
      this.getSourceData();
      this.getMarketer();
      this.getIntentCourseData();
    },
    // 绑定学员
    getcreateJG(n) {
      if (!n) {
        this.getBindingClientData(this.customerId);
      }
    },
    // 是否跟进提交失败
    // getisFllowError(){
    //   if(this.isFllowError){
    //     this.followForm.class_id = this.ClassMessage.class_cnname;
    //   }
    // }
    addTrackVisible(n) {
      if (!n) {
        this.addTrackForm.track_note = "";
        this.$refs["addTrackForm"].resetFields();
      }
    },
  },
  computed: {
    ClassMessageinfo() {
      return this.ClassMessage;
    },
    getcustomerId() {
      return this.customerId;
    },
    // 绑定学员
    getcreateJG() {
      return this.createJG;
    },
    companyIsmajor() {
      return this.$store.state.companyIsmajor; //0是免费版 1是普通版   2是专业版
    },
    // getisFllowError(){
    //   return this.isFllowError;
    // }
    companyIsNoIntention() {
      return this.$store.state.companyIsNoIntention;
    },
  },
  methods: {
    handleClose(done) {
      this.addTrackVisible = false;
      if (typeof done === "function") {
        done();
      }
    },
    handleAddTrackConfirm() {
      this.$refs["addTrackForm"].validate((valid) => {
        if (valid) {
          storeUser
            .addClientOnlyTrackOneApi({
              client_id: this.customerId,
              track_note: this.addTrackForm.track_note,
            })
            .then((res) => {
              if (res.data.code === 200) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.addTrackVisible = false;
                this.getclientOneTrackData();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
        } else {
          return false;
        }
      });
    },
    changeFilter(item) {
      this.currentId = item.id;
      this.getclientOneTrackData();
    },
    getInvalidnoteApi() {
      this.$http.getInvalidnoteApi({}).then((res) => {
        const { code, data: _jb } = res.data;

        const data = _jb;
        if (code === 200) {
          this.invalidNoteList = data.list;
        } else {
          this.invalidNoteList = [];
        }
      });
    },
    emitCallPhone(val) {
      this.$emit("emitCallPhone", val);
    },
    getInviteGenreApi() {
      storeUser.getInviteGenreApi({}).then((res) => {
        const { code, data: _jb } = res.data;

        const data = _jb;
        if (code === 200) {
          this.inviteGenreList = data.list;
        } else {
          this.inviteGenreList = [];
        }
      });
    },
    validateRete() {
      this.$refs["followForm"].validate();
    },
    //下拉列表->获取班组列表--zjb
    courseTypeRecruitApi() {
      this.$http
        .courseTypeRecruitApi({
          coursetype_isrecruit: 1,
          isFromTrack: 1,
          isopenclass: this.followForm.audition_genre === 0 ? 1 : 0,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.filterList.coursetypeList = res.data.data.list;
          } else {
            this.filterList.coursetypeList = [];
          }
        });
    },
    filterCourseCat() {
      this.followForm.coursecat_id = "";
      this.getTypeCourseCatApi();
    },
    getTypeCourseCatApi() {
      this.$http
        .getTypeCourseCatApi({
          coursetype_id: this.followForm.coursetype_id,
        })
        .then((res) => {
          const { code, data: _jb } = res.data;

          const data = _jb;
          if (code === 200) {
            this.filterList.courseCatList = data.list;
          } else {
            this.filterList.courseCatList = [];
          }
        });
    },
    // 意向客户管理->获取试听类型
    getAuditionTypesApi() {
      storeUser.getAuditionTypesApi({}).then((res) => {
        (() => {})(res, "getAuditionTypesApi");
        const { code, data: _jb } = res.data;

        const data = _jb;
        if (code === 200) {
          this.auditionTypesList = data.list;
        } else {
          this.auditionTypesList = [];
        }
      });
    },
    // 确定要选择的标签
    handConfirm(val) {
      let labelList = [];
      // val.forEach((item) => {
      //   labelList.push({
      //     label_id: item.label_id,
      //   });
      // });
      val.forEach((item) => {
        labelList.push(item.label_name);
      });
      this.$http
        .addClientTagsAction({
          client_id: this.customerId,
          label_list: JSON.stringify(labelList),
        })
        .then((res) => {
          (() => {})(res.data);

          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.$emit("updateList");
            this.getclientOneData(this.customerId);
            this.addTagVisable = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    //字符串转日期格式，strDate要转为日期格式的字符串
    getDate(strDate, strTime) {
      let b = strDate.split("-");
      let c = strTime.split(":");
      let date = new Date(b[0], b[1] - 1, b[2], c[0], c[1], c[2]);
      return this.$Common.formatDate(date);
    },
    emitShowImg(v) {
      this.$emit("emitShowImg", v);
    },
    // 渠道变更记录
    getChannelTrack(id) {
      storeUser
        .getChannelTrack({
          client_id: id,
        })
        .then((res) => {
          const { code, data: _jb } = res.data;

          const data = _jb;
          if (code === 200) {
            this.channelChangeList = data.data;
          } else {
            this.channelChangeList = [];
          }
        });
    },
    addConnect() {
      (() => {})("addConnect");
      this.$emit("addConnect");
    },
    linkToDetail() {
      this.$router.push({
        path: `/Customersmanage/ChannelChangeRecord?type=2&client_id=${this.UserInformation.client_id}`,
      });
    },
    //数据获取开始
    //获取招生渠道类型
    getSourceData() {
      storeUser
        .getSource({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          // (() => {})(res.data.data.list);
          this.SchoolsourceOption = res.data.data.list;
          this.SchoolsourceOption.unshift({
            frommedia_id: "",
            frommedia_name: this.$t("Common.options"),
          });
        });
    },
    // 获取招生的负责人
    getMarketer() {
      storeUser
        .getMarketer({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.chiefPerson = res.data.data.list;
          // this.chiefPerson.unshift(
          //   {
          //     marketer_id: "", marketer_name: "不限"
          //   })
        });
    },
    //接待人->获取有接待权限的接待人
    getReceiverList() {
      storeUser
        .getReceiverList({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.ReceiverList = res.data.data.list;
        });
    },
    //获取意向课程
    getIntentCourseData() {
      // SchoolClassOption
      storeUser
        .getIntentCourse({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          (() => {})(res.data);
          this.SchoolCourseOption = res.data.data.list;
          //重置筛选
          // this.SchoolCourseOption.unshift(
          //   {
          //     coursecat_id: "", coursecat_cnname
          //   }
          // );
        });
    },
    // 获取单个客户的基本信息
    getclientOneData(id) {
      (() => {})(this.isForm, 1111111);
      var fromValue;
      if (this.isForm) {
        fromValue = "1";
      } else {
        fromValue = "";
      }
      storeUser
        .getclientOne({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id, //所属集团
          client_id: id,
          from: fromValue,
        })
        .then((res) => {
          (() => {})(res.data.data.is_track);
          this.UserInformation = res.data.data.list;
          this.answerphoneDisabled =
            res.data.data.list.client_answerphone != 0;
          this.followForm.client_answerphone =
            res.data.data.list.client_answerphone;
          this.followForm.track_answerphone =
            res.data.data.list.client_answerphone == 1 ? "1" : "-1";
          this.num = parseInt(this.UserInformation.client_intention_level);
          this.maxNum = parseInt(
            this.UserInformation.client_intention_maxlevel
          );
          if (res.data.data.is_track == "1") {
            this.isyhavetrack = true;
            this.isyhavetrackedit = true;
            // this.activeName = "fourth";
            if (this.activeName == "first") {
              this.isRoottrack = false;
              this.isyhavetrackedit = false;
            }
          } else {
            this.isyhavetrack = false;
            this.isyhavetrackedit = false;
          }

          (() => {})(this.UserInformation);
        });
    },
    // 获取单个客户的跟踪记录
    getclientOneTrackData() {
      storeUser
        .getclientOneTrack({
          client_id: this.customerId,
          track_isactive: this.currentId == -1 ? "" : this.currentId,
        })
        .then((res) => {
          var arr = [];
          res.data.data.list.forEach((item) => {
            var str = item.track_followmode_name;
            arr.push(
              Object.assign({}, item, {
                track_followcont: str,
                isClickReply: false,
                replay_note: "",
              })
            );
          });
          this.recordData = arr;
          this.recordDatalen = this.recordData.length;

          if (this.currentId == -1) {
            this.currentrecordData = arr.slice(0, 2);
          }
        });
    },
    // 获取单个客户的绑定关系
    getFriendRelationData(id) {
      storeUser
        .getFriendRelation({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          client_id: id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.FriendRelation = res.data.data.list;
        });
    },
    // 获取单个客户的绑定学员信息
    getBindingClientData(id) {
      // BindingInfor
      storeUser
        .getBindingClient({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id, //所属集团
          client_id: id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.BindingInfor = res.data.data.list;
          this.BindingInforlen = this.BindingInfor.length;
        });
    },
    // 绑定学员->获取人员名称
    getClientNameData() {
      storeUser
        .getClientName({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          // (() => {})(res.data.data.list);
          this.FriendName = res.data.data.list;
        });
    },
    // 获取单个客户的柜询记录-
    getclientOneInviteData(id) {
      storeUser
        .getclientOneInvite({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id, //所属集团
          client_id: id,
        })
        .then((res) => {
          this.tryRecordlist = res.data.data.list;
          var Columns = res.data.data.field;
          this.recordlistColumn = this.$Common.handleTable(
            Columns,
            this.recordcolumnWidth,
            false,
            0
          );
          if (res.data.code !== 200) {
            this.recordoptions.errortip = res.data.msg;
          }
        });
    },
    //获取单个客户的试听记录-
    getclientOneAuditionData(id) {
      storeUser
        .getclientOneAudition({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id, //所属集团
          client_id: id,
        })
        .then((res) => {
          this.tryClasslist = res.data.data.list;
          var Columns = res.data.data.field;
          this.ClasslistColumn = this.$Common.handleTable(
            Columns,
            this.ClasscolumnWidth,
            false,
            0
          );
          if (res.data.code !== 200) {
            this.Classoptions.errortip = res.data.msg;
          }
        });
    },
    //个人详情->获取第三方的外播记录-lujing
    getThreeTrackApi() {
      storeUser
        .getThreeTrackApi({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id, //所属集团
          client_id: this.customerId,
        })
        .then((res) => {
          if (res.data.code === 200) {
            let datalist = res.data.data.datalist;
            this.OutboundList = datalist;
            this.OutboundList.forEach((e, index) => {
              this.playMehod(index);
            });
          } else {
            this.OutboundList = [];
          }
        });
    },
    // 音频初始化
    playMehod(index) {
      this.$nextTick(() => {
        this.$set(
          this.OutboundList[index],
          "allPlayTime",
          Math.ceil(this.OutboundList[index]["outcall_duration"])
        );
        this.$set(this.OutboundList[index], "currentPlayTime", 0);
        // let audio = document.getElementsByClassName("myaudio");
        // let _this = this;
        // if (audio.length > 0) {
        //   Array.prototype.forEach.call(audio, function(element, index) {
        //     element.load();
        //     element.oncanplay = function() {
        //       (() => {})(element.duration, index);
        //       _this.$set(
        //         _this.OutboundList[index],
        //         "allPlayTime",
        //         element.duration
        //       );
        //     };
        //   });
        //   (() => {})(this.OutboundList, 11212);
        // }
      });
    },
    // 音频点击播放
    autoPlay(audioIndex) {
      this.OutboundList.forEach((e, index) => {
        e.isPlay = false;
        if (audioIndex == index) {
          e.isPlay = true;
        }
      });
    },
    // 公共->意向星级注释列表->zjc
    getIntentionLevelList() {
      this.$http.getIntentionLevelList({}).then((res) => {
        const { code, data: _jb } = res.data;

        const data = _jb;
        if (code === 200) {
          this.intentionLevelList = data.list;
        } else {
          this.intentionLevelList = [];
        }
        // let list = res.data.data.list;
        // let arr = [];
        // list.forEach((e) => {
        //   arr.push(e.intentlevel_remark);
        // });
        // this.intentionLevelList = arr;
      });
    },
    // 获取沟通类型
    getCommodeData() {
      storeUser
        .getCommode({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          this.CommodeData = res.data.data.list;
          (() => {})(res.data.data.list);
        });
    },
    // 获取沟通对象
    getObjectApi() {
      storeUser
        .getObjectApi({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          this.ObjectData = res.data.data.list;
          (() => {})(res.data.data.list);
        });
    },
    // 获取沟通模板
    getTraceNoteData() {
      storeUser
        .getTraceNote({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          this.TraceNoteData = res.data.data.list;
          (() => {})(res.data.data.list);
        });
    },
    //主管回复跟踪记录->ling
    levelReplayTrackAction(item, index) {
      storeUser
        .levelReplayTrackAction({
          track_id: this.oneTrackInfo.track_id,
          replay_note: this.oneTrackInfo.replay_note,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.recordData[index].isClickReply = false;
            this.currentrecordData = this.recordData.slice(0, 2);
            this.getclientOneTrackData();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    //主管审阅点评记录->luijng
    levelReadTrackAction() {
      storeUser
        .levelReadTrackAction({
          track_id: this.oneTrackInfo.track_id,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getclientOneTrackData();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    // 点击阅读
    handRead(item, index) {
      (() => {})(item, index);
      this.oneTrackInfo = item; //单个跟踪记录信息
      this.levelReadTrackAction(); //主管审阅点评记录->luijng
    },
    // 点击回复
    handReply(item, index) {
      (() => {})(item, index);
      this.oneTrackInfo = item; //单个跟踪记录信息
      this.recordData[index].isClickReply = true;
      this.currentrecordData = this.recordData.slice(0, 2);
    },
    // 关闭取消回复框
    handCloseReply(item, index) {
      (() => {})(item, index);
      this.recordData[index].isClickReply = false;
      this.recordData[index].replay_note = "";
      this.currentrecordData = this.recordData.slice(0, 2);
    },
    //数据获取结束
    hideUserSliderBox() {
      this.$emit("hideUserSliderBox");
    },
    onFllowSubmit(v) {
      this.$refs["followForm"].validate((valid) => {
        if (valid) {
          v.class_id = this.ClassId;
          v.course_id = this.CourseId;
          v.hour_id = this.HourId;

          v.invalidnote_reason =
            this.followForm.track_followmode == -2
              ? this.invalidNoteList.find(
                  (item) => item.invalidnote_code == v.invalidnote_code
                )["invalidnote_reason"]
              : "";

          if (this.isClickBand) {
            v.client_id = this.fllow_id;
          } else {
            v.client_id = this.customerId;
          }
          this.$emit("onFllowSubmit", v);
        } else {
          return false;
        }
      });
    },
    // 绑定的学员跟进点击
    ClickFloow(v) {
      // 数据初始化
      this.followForm.client_id = "";
      this.followForm.track_linktype = "";
      this.followForm.client_answerphone = "";
      this.followForm.track_answerphone = "-1";
      this.followForm.track_validinc = "";
      this.followForm.track_intention_level = 0;
      this.followForm.track_followuptype = "";
      this.followForm.track_followuptime = "";
      this.followForm.track_followmode = ""; //本次跟进模式0普通回访1柜询2试听3转正-1跟进无意向
      // track_note_temp = "" //沟通模板不需要传
      this.followForm.track_note = "";
      this.followForm.class_id = "";
      this.followForm.class_cnname = "";
      this.followForm.invite_genre = ""; //邀约柜询类型 邀约类型 变量 0普通柜询1能力测试
      this.followForm.client_lapsedtype = ""; //无意向类型 0已报异业1强烈抵触2其他
      this.followForm.object_code = ""; //沟通对象
      this.followForm.audition_genre = ""; //试听类型
      this.followForm.receiver_name = ""; //接待人

      this.followForm.className = "";
      this.ClassId = "";
      this.CourseId = "";
      this.bindRoot = true;
      this.activeName = "fourth";
      this.isRoottrack = true;
      this.isClickBand = true;
      (() => {})(v);
      this.$emit("ClickFloow", v);
    },
    studentBinding() {
      this.$emit("studentBinding");
    },
    Clickedit() {
      this.$emit("Clickedit");
    },
    leaning() {
      this.$emit("leaning");
    },
    // 选择试听类型
    ClickAudition() {
      this.followForm.className = "";
      this.followForm.class_id = "";
      this.followForm.class_cnname = "";
      this.followForm.coursetype_id = "";
      this.followForm.coursecat_id = "";
      this.$emit("ClickAudition", this.followForm.audition_genre);
      this.courseTypeRecruitApi();
    },
    // 选择试听时间
    ClickAuditiontime() {
      this.followForm.className = "";
      this.followForm.class_id = "";
      this.followForm.class_cnname = "";
      this.$emit("ClickAuditiontime", this.followForm.audition_visittime);
    },
    //更多下拉
    handmoreVisible() {
      if (this.moreVisible == false) {
        this.moreVisible = true;
      } else {
        this.moreVisible = false;
      }
    },
    // 选择模板时
    handClickModel() {
      this.followForm.track_note = this.checkList;
    },
    // tab, event
    handleSliderClick() {
      // (() => {})(this.isRoot,this.iscanEdit,this.tabEdit)
      if (this.activeName == "first") {
        this.getclientOneData(this.customerId);
        this.tabEdit = true;
        this.isRoottrack = false;
      } else {
        if (this.activeName == "fourth") {
          this.followForm.client_id = "";
          this.followForm.track_linktype = "";
          this.followForm.track_validinc = "";
          this.followForm.track_intention_level = 0;
          this.followForm.track_followuptype = "";
          this.followForm.track_followuptime = "";
          this.followForm.track_followmode = ""; //本次跟进模式0普通回访1柜询2试听3转正-1跟进无意向
          // this.followForm.track_note_temp = '' //沟通模板不需要传
          this.followForm.track_note = "";
          this.followForm.class_id = "";
          this.followForm.class_cnname = "";
          this.followForm.invite_genre = ""; //邀约柜询类型 邀约类型 变量 0普通柜询1能力测试
          this.followForm.client_lapsedtype = ""; //无意向类型 0已报异业1强烈抵触2其他
          this.followForm.object_code = ""; //沟通对象
          this.followForm.audition_genre = ""; //试听类型
          this.followForm.receiver_name = ""; //接待人

          this.isRoottrack = true;
          this.isyhavetrackedit = true;
          this.getCommodeData();
          this.getReceiverList();
          this.getObjectApi();
          this.getTraceNoteData();
        } else {
          this.isRoottrack = false;
        }
        this.tabEdit = false;
        this.isyhavetrackedit = false;
      }
      if (this.activeName == "second") {
        this.getclientOneTrackData();
      }
      if (this.activeName == "third") {
        this.getclientOneInviteData(this.customerId);
        this.getclientOneAuditionData(this.customerId);
      }
      if (this.activeName == "fives") {
        this.getBindingClientData(this.customerId);
      }
      if (this.activeName == "sixed") {
        // 外拨记录
        this.getThreeTrackApi();
        (() => {})(this.$t("components.User.seeing.52b5hn58vb40"));
      }
      this.$emit("handleSliderClick", this.activeName);
    },
    // 关闭更多
    closeMore(event) {
      var btn = document.querySelector(".btn-binding");
      if (btn) {
        if (!btn.contains(event.target)) {
          //按钮.app-download以外的区域
          this.moreVisible = false;
        }
      }
    },
    sourceFilter() {
      // 数据初始化
      this.followForm.track_followuptype = "";
      this.followForm.track_followuptime = "";
      // this.followForm.track_note = "";
      this.followForm.class_id = "";
      this.followForm.receiver_name = "";
      this.followForm.class_cnname = "";
      this.followForm.coursetype_id = "";
      this.followForm.coursecat_id = "";
      this.checkList = "";
      this.followForm.audition_genre = "";
      this.followForm.className = "";
      this.ClassId = "";
      this.CourseId = "";
      // this.followForm.audition_visittime="";
      (() => {})(this.checkList);
      this.courseTypeRecruitApi();
    },
  },
};
</script>

<style lang="less" scoped>
.slider-top-see .myinfo .el-info-row {
  margin-right: 25px !important;
}

.user-seeing .slider-top-see {
  .slider-person-info {
    .myinfo {
      margin-bottom: 12px;

      .contact-name {
        min-width: 50px;
        display: inline-block;
      }
    }

    .tag-list {
      padding: 0px 10px 0 96px !important;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      width: 100%;
      height: 40px;

      .tagItem {
        text-align: center;
        display: block;
        min-width: 80px;
        height: 28px;
        line-height: 28px;
        border-radius: 15px;
        color: #28abd9;
        font-size: 14px;
        padding: 0 18px;
        border: 1px solid #28abd9;
        margin-right: 20px;
        margin-bottom: 10px;
      }
    }

    .addTagBtn {
      color: #28abd9;
      cursor: pointer;
      line-height: 38px;
    }
  }

  .form-info-cont .course {
    flex: none !important;
  }
}

// 意向星级样式
.el-rate {
  height: 40px;
  line-height: 40px;

  i {
    line-height: 40px;
  }
}

.btn-biding-disable {
  background: #ddd;
  border-color: #ddd;
}

.btn-biding-disable:hover,
.btn-biding-disable:focus {
  background: #ddd;
  border-color: #ddd;
}

.el-rate i {
  // color:#FF8A00!important;
}

.user-seeing .silder-contain .slider-cont .BaseInfo .form-info-cont label {
  width: 135px !important;
}

.user-seeing .silder-contain .slider-cont .BaseInfo .form-info-cont {
  display: flex;
  align-items: center;

  // 推荐人信息
  .recommend-info {
    display: flex;
    align-items: center;

    span {
      display: inline-block;
      width: 1px;
      height: 20px;
      margin: 0 10px;
      background: rgba(223, 223, 223, 1);
    }
  }
}

.user-seeing .silder-contain .el-tabs__nav {
  padding: 0 0px 0px 0px;
}

.user-seeing {
  .el-row .grid-content-img img {
    height: 100%;
  }

  .slider-studentBind .el-row .el-col {
    min-height: 178px;
  }

  .el-row .grid-content > p {
    height: auto;
  }

  .el-row .grid-content .communite-cont {
    line-height: 28px;
    display: flex;
    justify-content: space-between;

    p {
      flex: 1;
    }

    .btns {
      width: 135px;
      margin-left: 10px;

      .el-button {
        width: 60px;
      }

      .btn-disabled {
        background-color: #cccccc;
        border-color: #cccccc;
      }
    }
  }

  .el-row .grid-content .communite-replay {
    display: flex;
    border-top: 1px dashed #ddd;

    .replay-cont {
      flex: 1;
      line-height: 24px;
    }

    .img {
      width: 40px;
      height: 40px;
      overflow: hidden;
      border-radius: 50%;
      margin-right: 10px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .replay-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  // 外拨记录样式
  .slider-phoneRecord {
    .Outbound-list {
      // .itemOne {
      //   padding: 10px;
      //   margin-bottom: 10px;
      //   border: 1px solid rgba(221, 221, 221, 1);
      //   display: flex;
      //   align-items: center;
      //   justify-content: space-between;
      //   .time {
      //     color: #aaa;
      //   }
      // }
      .itemOne {
        margin-top: 25px;
        padding-bottom: 10px;
        border-bottom: 1px dotted #cccccc;
        display: flex;

        .outbound-left {
          margin-right: 10px;

          img {
            width: 72px;
            height: 72px;
            border-radius: 50%;
          }
        }

        .outbound-right {
          flex-grow: 1;
          flex-shrink: 1;
          .outbound-content {
            img {
              margin-right: 8px;
            }
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #55606e;
          }

          .outbound-header {
            display: flex;
            align-items: center;
            margin-bottom: 10px;

            .cname {
              font-size: 16px;
              color: #55606e;
              margin-right: 20px;
            }

            .label {
              font-size: 14px;
              color: #aaaaaa;
              padding: 2px 6px;
              border-radius: 12px;
              border: 1px solid #dddddd;
            }

            .time {
              flex-grow: 1;
              display: flex;
              justify-content: flex-end;
              font-size: 14px;
              color: #a4a4a4;
            }
          }
        }
      }
    }
  }
}

.channel-link {
  margin-left: 25px;
  font-style: normal;
  cursor: pointer;
  color: rgba(40, 171, 217, 1);
}

.channel-history {
  margin: 0 0 0 10px;
  padding-bottom: 10px;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    top: 10px;
    width: 1px;
    height: 100%;
    background-color: rgba(40, 171, 217, 1);
    border-radius: 50%;
  }

  &:first-child {
    padding-top: 0;
  }

  .channel-history__title {
    margin: 0 0 10px 0;
    padding-left: 15px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #a4a4a4;
    line-height: 20px;
    letter-spacing: 1px;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      left: -5px;
      top: 5px;
      width: 6px;
      height: 6px;
      padding: 2px;
      border: 1px solid rgba(0, 173, 223, 1);
      background-color: rgba(0, 173, 223, 1);
      background-clip: content-box;
      border-radius: 50%;
    }
  }

  .channel-history-box {
    width: 96%;
    margin: 0 auto;
    padding: 20px 30px;
    box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.08);

    .channel-row {
      display: flex;
      align-items: flex-start;

      .channel-detail {
        display: flex;
        flex: 5;
        padding: 16px 0;
        align-items: center;
        justify-content: space-around;
        background-color: rgba(32, 168, 216, 0.05);

        .channel-detail__content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: #3a3a3a;
          line-height: 19px;
          letter-spacing: 1px;

          p {
            margin-top: 20px;
            &:first-child {
              margin-top: 0;
            }
          }
        }

        .channel-detail__tips {
          display: flex;
          flex-direction: column;
          align-items: center;

          img {
            width: 47px;
            height: 25px;
          }

          p {
            font-size: 12px;
            font-family: MicrosoftYaHei;
            color: #aaaaaa;
            line-height: 16px;
            letter-spacing: 1px;
          }
        }
      }

      .channel-status {
        flex: 2;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .dot {
          width: 6px;
          height: 6px;
          margin-right: 5px;
          border-radius: 50%;
        }

        &.status-success {
          color: rgba(6, 217, 3, 1);

          .dot {
            background-color: rgba(6, 217, 3, 1);
          }
        }

        &.status-fail {
          color: rgba(243, 92, 92, 1);

          .dot {
            background-color: rgba(243, 92, 92, 1);
          }
        }

        &.status-wait {
          color: rgba(32, 168, 216, 1);

          .dot {
            background-color: rgba(32, 168, 216, 1);
          }
        }

        &.status-warn {
          color: rgba(255, 203, 0, 1);

          .dot {
            background-color: rgba(255, 203, 0, 1);
          }
        }
      }
    }
  }

  .channel-history__teacher {
    margin-top: 20px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #55606e;
    line-height: 19px;
    letter-spacing: 1px;

    &:last-child {
      margin-top: 10px;
    }
  }
}

.sele-sty /deep/ .el-input.el-input--mini .el-input__inner {
  border-radius: 20px;
  border: 1px solid #20a8d8;
  color: #20a8d8;
}

.sele-sty /deep/ .el-input.el-input--mini .is-disabled .el-input__inner {
  border-radius: 20px;
  border: 1px solid #20a8d8;
  color: #20a8d8;
}

.content-nav--head {
  margin-top: -10px;
  .filter-condition {
    display: flex;
    align-items: center;
    .link-active {
      color: #20a8d8;
      border-bottom: 2px solid #20a8d8;
    }
    li {
      height: 45px;
      line-height: 45px;
      margin-right: 25px;
      cursor: pointer;
      position: relative;

      .tag-num {
        position: absolute;
        top: 8px;
        right: -2px;
        background-color: red;
        color: #fff;
        width: 20px;
        height: 20px;
        border-radius: 20px;
        font-size: 12px;
        text-align: center;
        line-height: 20px;
      }
    }
  }
}
</style>
<style lang="less">
.rate-startLevel-diy {
  position: relative;
  .el-rate__text {
    font-size: 12px;
    position: absolute;
    width: 100%;
    bottom: -10px;
    left: 0;
    line-height: 100%;
  }
}

.user-seeing {
  .el-radio--small.is-bordered {
    height: auto;
    min-width: 340px;
    display: flex;
    align-items: center;
    padding-bottom: 8px;
  }
  .el-radio--small.is-bordered .el-radio__label {
    font-size: 14px;
    left: 20px;
  }
}
</style>
